import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';

import type { ComponentProps } from '~/chords/ComponentProps';

export const SlideOutFooter = forwardRef<
  HTMLDivElement,
  Omit<ComponentProps<HTMLAttributes<HTMLDivElement>>, 'className'>
>(({ children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      {...props}
      className="flex justify-end gap-lg border-t-px px-lg py-md bg-level-03 border-emphasis-subtle"
    >
      {children}
    </div>
  );
});

SlideOutFooter.displayName = 'SlideOut.Footer';
